exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preline {\r\n  white-space: pre-line;\n}\ntextarea {\r\n  resize: vertical;\n}\r\n", ""]);

// exports
